import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography, TypographyProps } from '@mui/material';
import { Flag } from 'components/_commons/Flag';
import React, { useCallback } from 'react';
import { ItemOption, SelectField } from '..';

const SelectItemWithLeftElement = ({
                                     isClearable = false,
                                     isFlagElement,
                                     isLoading,
                                     label = 'common.selectOption',
                                     leftElement,
                                     name,
                                     onChange,
                                     options,
                                     placeholder,
                                     required = false,
                                     value = null,
                                     valueLabelVariant,
                                     ...props
                                   }: {
  isClearable?: boolean,
  isFlagElement?: boolean,
  isLoading?: boolean,
  label?: string,
  leftElement?: (data: any) => React.ReactNode,
  name: string,
  onChange: (value: any) => void,
  options: any[],
  placeholder?: string,
  required?: boolean,
  value: any,
  valueLabelVariant?: Exclude<TypographyProps['variant'], 'srOnly'> | 'srOnly'
}) => {
  const handleChange = useCallback(language => onChange(language), [onChange]);

  const CustomOption = ({ data, innerProps }: { data: any, innerProps: any }) => {
    const optionFlag = <Flag alt={data.countryCode ?? data.value} countryCode={data.countryCode ?? data.value} isInsideSelect style={{ margin: '3px 10px' }} />;
    return (
      <ItemOption {...innerProps} isInsideSelect>
        {isFlagElement ? optionFlag : leftElement && leftElement(data)}
        <Typography>
          {data.label}
        </Typography>
      </ItemOption>
    );
  };

  const CustomValue = ({ data, innerProps }: { data: any, innerProps: any }) => {
    const valueFlag = <Flag alt={data.countryCode ?? data.value} countryCode={data.countryCode ?? data.value} isInsideSelect style={{ margin: '5px 0' }} />;
    const isSrOnly = valueLabelVariant === 'srOnly';
    const srOnlyStyles = isSrOnly ? {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: '0',
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0,0,0,0)',
      border: '0'
    } : {};

    return (
      <ItemOption {...innerProps} style={{ gridArea: ' 1/1/2/3' }}>
        {isFlagElement ? valueFlag : leftElement && leftElement(data)}
        <Typography
              sx={{
                margin: '0.8rem',
                whiteSpace: 'nowrap',
                ...srOnlyStyles
              }}
              variant={isSrOnly ? 'body1' : valueLabelVariant as Exclude<TypographyProps['variant'], 'srOnly'>}
          >
          {data.label}
        </Typography>
      </ItemOption>
    );
  };

  return (
      isLoading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : (
        <SelectField
              components={{ Option: CustomOption, SingleValue: CustomValue }}
              isClearable={isClearable}
              label={label}
              name={name}
              options={options}
              placeholder={placeholder}
              required={required}
              value={value}
              onChange={handleChange}
              {...props}
          />
      )
  );
};

export default SelectItemWithLeftElement;
